// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zaz7","largestCol":"styles_largestCol__1WR5v","smallestCol":"styles_smallestCol__1l-Ri"};